import { Box } from '@mui/material';
import React from 'react';
import logo from '../../images/logo.png'; // Import your logo image here

const BudgetPlanningLetter = () => {
  return (
    <Box
      sx={{
        padding: 5,
        margin: 5,
        width: {
          lg: '50%',
        },
        border: '1px solid gray',
      }}
    >
      <img src={logo} alt="New Mt. Zion Missionary Baptist Church logo" />
      {/* <h3 style={{ textAlign: 'center', color: '#a5545a', fontWeight: 'bold' }}>
        New Mt. Zion Missionary Baptist Church
      </h3> */}
      <div style={{ display: 'flex', height: '5px' }}>
        <div style={{ flex: 1, backgroundColor: '#facc02' }}></div>
        <div style={{ flex: 1, backgroundColor: '#660066' }}></div>
        <div style={{ flex: 1, backgroundColor: '#facc02' }}></div>
      </div>
      <h2 style={{ textAlign: 'center' }}>
        2027 Annual Ministry Budget Planning Letter
      </h2>
      <h3 style={{ textAlign: 'center' }}>DATE: AUGUST 25, 2026</h3>
      <p>Dear Ministry Leaders,</p>
      <p>
        Greetings in the precious name of our Lord and Savior, Jesus Christ!
      </p>
      <p>
        As we prepare for the 2027 fiscal year, we give thanks to God for His
        continued faithfulness and blessings upon New Mt. Zion Missionary
        Baptist Church. Our ministry focus remains centered on Making
        Disciples through teaching the Word of God and Evangelism, while
        continuing to meet the needs of our growing congregation. We are also
        grateful for the upcoming Youth Building Renovation, which will
        provide additional space to support the growth of our Youth and
        Children’s Ministry. We look forward with faith and expectation to
        all that God will accomplish through these efforts.
      </p>
      <p>
        Our annual church budget is an important tool for achieving our
        mission and ministry goals. It is developed with consideration of our
        church’s goals, historical information, anticipated income, and
        projected expenses. Your ministry’s goals, activities, and funding
        needs are essential to this process. We ask that you prayerfully and
        carefully consider your ministry’s plans and the resources needed to
        accomplish them as you complete the 2027 Budget Request Form. The
        budget timeline is listed below:
      </p>
      <table border={1} cellPadding="5" cellSpacing="0">
        <thead>
          <tr>
            <th style={{ backgroundColor: '#ffdc9e' }}>DATE</th>
            <th style={{ backgroundColor: '#ffdc9e' }}>ACTIVITY</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Tuesday, September 1, 2026</td>
            <td>
              Budget letter and forms distributed electronically at{' '}
              <a href="/">www.nmzlakeland.org</a>
            </td>
          </tr>
          <tr>
            <td>Tuesday, October 6, 2026</td>
            <td>The final date for the submission of budget request forms.</td>
          </tr>
        </tbody>
      </table>
      <p>
        Thank you for your thoughtful and prayerful participation in this
        important work. May God guide our planning and help us faithfully
        steward the resources He has entrusted to us as we continue to
        advance the mission and ministry of New Mt. Zion. May God continue to
        guide, bless, and strengthen us as we serve Him together. We look
        forward to an amazing year of ministry, service, and spiritual
        growth!
      </p>
      <p>Blessings,</p>
      <p>
        New Mt. Zion Missionary Baptist Church Budget Committee:
        <br />
        Sister Barbara Harrison, Chair
        <br />
        Sister Doretha Brooks, Church Accountant
        <br />
        Deacon Jesse Moore
        <br />
        Sister Baretta Oliver
        <br />
        Sister Briana Resto
      </p>
    </Box>
  );
};

export default BudgetPlanningLetter;
